import { ref } from 'vue';
import { useToasted } from './useToasted';

export const useCopyText = () => {
    const toasted = useToasted();

    const copiedText = ref('');

    let copiedTextTimeout;
    /**
     * @param {boolean|string} [toast] true → default "<text> copied to clipboard." message; false → no toast; a string → that message.
     */
    const copyText = (text, toast = true) => {
        navigator.clipboard.writeText(text);
        if (toast !== false) {
            toasted.success(typeof toast === 'string' ? toast : `${text} copied to clipboard.`);
        }

        copiedText.value = text;

        clearTimeout(copiedTextTimeout);
        copiedTextTimeout = setTimeout(() => {
            copiedText.value = '';
        }, 1000);
    };

    return {
        copiedText,
        copyText,
    };
};
